<template>
  <div>
    <TableFilters
      :filters="['brand', 'supplier', 'category']"
      :columns="columns"
      @updateColumnsTable="updateColumnsTable"
      v-model="filter"
      :export="[`productexport`]"
    ></TableFilters>
    <v-row class="py-0 my-0">
      <v-col cols="12" md="12" lg="7" class="pa-5">
        <v-btn-toggle v-model="toggle_exclusive">
          <v-btn
            @click="
              goto('indextable');
              viewpdfFile();
            "
          >
            View Report
          </v-btn>
          <v-btn @click="exportPDF()"> Generate PDF </v-btn>
          <v-btn @click="exceldownload()"> Generate CSV </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-card class="mt-2" v-show="false">
      <v-container fluid>
        <v-row>
          <v-card-text class="pa-0">
            <v-data-table
              :items-per-page="1000"
              :fixed-header="true"
              :headers="headers"
              :items="products"
              item-key="id"
              style="margin-top: 100"
              class="row-pointer product-list"
              id="indextable"
            >
              <template v-slot:item.code="{ item }">
                <CopyTableCell :text="item.code"></CopyTableCell>
              </template>
              <!-- No -->

              <!-- Image -->
              <template v-slot:item.image="{ item }">
                <img
                  v-if="item.image"
                  :src="item.image"
                  height="32"
                  width="32"
                  class="image"
                />
                <v-avatar v-else size="32px" item color="primary">
                  <span class="white--text subtitle-2 text-uppercase">
                    {{ item.name.substring(0, 2) }}</span
                  >
                </v-avatar>
              </template>

              <!-- Category -->
              <template v-slot:item.category="{ item }">{{
                item.category.name ? item.category.name : '-'
              }}</template>

              <!-- Brand -->
              <template v-slot:item.brand="{ item }">{{
                item.brand.name ? item.brand.name : '-'
              }}</template>
            </v-data-table>
          </v-card-text>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
// Components
import PageTitle from '@/components/shared/PageTitle';
import ProductListPdf from './PDF/ProductsList.vue';
import TableFilters from '@/components/base/TableFilters';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import XLSX from 'xlsx';
import { DateTime } from '@grapecity/wijmo';
import moment from 'moment';
import _ from 'lodash';
import { mapState } from 'vuex';
export default {
  data: () => ({
    columns: [
      {
        text: 'No',
        value: 'no',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.no,
      },
      {
        text: 'Referance No',
        value: 'reference_number',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.reference_number,
      },
      {
        text: 'Name',
        value: 'name',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.name,
      },
      {
        text: 'Code',
        value: 'code',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.code,
      },
      {
        text: 'Category',
        value: 'category',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.category.name,
      },
      {
        text: 'Brand',
        value: 'brand',
        show: true,
        disabled: false,
        width: '14%',
        render: (item) => item?.brand.name,
      },
    ],
    products: [],
    hide: '',
    // Filters
    filter: {
      category: '',
      search: '',
      brand: '',
      status: '',
    },
  }),
  components: {
    PageTitle,
    TableFilters,
    ProductListPdf,
  },

  methods: {
    updateColumnsTable() {
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);
      setTimeout(() => {
        this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
        this.$store.commit('UPDATE_PDF_VISIBLE', true);
        this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
      }, 100);
    },
    generateReport(callBack = () => {}) {
      this.$store.commit('UPDATE_PDF_VISIBLE', true);
      this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', true);

      var filter = this.filter;
      this.$store
        .dispatch('report/getProductReports', filter)
        .then((res) => {
          let i = 1;
          this.products = res.data.data;
          this.products.map((p) => {
            p.no = i;
            i++;
          });
          setTimeout(() => {
            // Update Pdf To List

            this.$store.commit('UPDATE_PDF_HEADERS', this.headers);
            // Update Pdf To List Datas
            this.$store.commit('UPDATE_PDF_DATAS', this.products);
            // Update Pdf To List_Title
            this.$store.commit('UPDATE_PDF_TITLE', 'Products');
            this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
            callBack();
          }, 100);
        })
        .catch((err) => {
          this.isLoading = false;
          this.$store.commit('UPDATE_PDF_VISIBLE', false);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);

          this.messages = err.data.title;
        });
    },
    async viewpdfFile() {
      await this.generateReport();
      setTimeout(() => {
        if (this.products.length > 0) {
          this.$store.commit('UPDATE_PDF_VISIBLE', true);
          this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
        }
      }, 1000);
    },

    exportPDF() {
      const printPdf = () => {
        let Data = _.cloneDeep(this.products);
        for (let x = 0; x < Data.length; x++) {
          Data[x].category = Data[x].category.name;
          Data[x].brand = Data[x].brand.name;
          Data[x].refno = Data[x].reference_number;
          Data[x].suppliers = Data[x].suppliers.map((i) => {
            return i.name;
          });
        }
        var rows = Data;
        var doc = jsPDF({
          orientation: 'landscape',
        });
        doc.setFontSize(13);
        // doc.setFontType("bold");
        doc.setTextColor(26, 26, 26);
        doc.setFont('helvetica', 'normal');
        doc.text('Product Report', 14, 6);

        doc.setFontSize(8);
        doc.text(
          250,
          6,
          `Generated Date and Time  -  ${moment(today).format(
            'DD-MM-YYYY HH:MM:SS',
          )}`,
          'center',
        );

        // let height;
        // if (
        //   (this.filterDatas.brandquery == "" ||
        //     this.filterDatas.brandquery == null) &&
        //   (this.filterDatas.categoryquery == "" ||
        //     this.filterDatas.categoryquery == null) &&
        //   (this.filterDatas.supplierquery == "" ||
        //     this.filterDatas.supplierquery == null)
        // ) {
        //   height = 10;
        // } else if (
        //   (this.filterDatas.categoryquery == "" ||
        //     this.filterDatas.categoryquery == null) &&
        //   (this.filterDatas.supplierquery == "" ||
        //     this.filterDatas.supplierquery == null)
        // ) {
        //   this.filterDatas.brandquery
        //     ? doc.text(`Brand  -    ${this.filterDatas.brandquery}`, 14, 12)
        //     : null;
        //   height = 15;
        // } else if (
        //   (this.filterDatas.brandquery == "" ||
        //     this.filterDatas.brandquery == null) &&
        //   (this.filterDatas.supplierquery == "" ||
        //     this.filterDatas.supplierquery == null)
        // ) {
        //   this.filterDatas.categoryquery
        //     ? doc.text(
        //         `Category  -    ${this.filterDatas.categoryquery}`,
        //         14,
        //         12
        //       )
        //     : null;
        //   height = 15;
        // } else if (
        //   (this.filterDatas.brandquery == "" ||
        //     this.filterDatas.brandquery == null) &&
        //   (this.filterDatas.categoryquery == "" ||
        //     this.filterDatas.categoryquery == null)
        // ) {
        //   this.filterDatas.supplierquery
        //     ? doc.text(
        //         `Supplier  -    ${this.filterDatas.supplierquery}`,
        //         14,
        //         12
        //       )
        //     : null;
        //   height = 15;
        // } else if (
        //   this.filterDatas.brandquery == "" ||
        //   this.filterDatas.brandquery == null
        // ) {
        //   this.filterDatas.supplierquery
        //     ? doc.text(
        //         `Supplier   -    ${this.filterDatas.supplierquery}`,
        //         14,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.categoryquery
        //     ? doc.text(
        //         `Category  -    ${this.filterDatas.categoryquery}`,
        //         14,
        //         17
        //       )
        //     : null;
        //   height = 20;
        // } else if (
        //   this.filterDatas.categoryquery == "" ||
        //   this.filterDatas.categoryquery == null
        // ) {
        //   this.filterDatas.supplierquery
        //     ? doc.text(
        //         `Supplier    -    ${this.filterDatas.supplierquery}`,
        //         14,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.brandquery
        //     ? doc.text(
        //         `Brand       -    ${this.filterDatas.brandquery}`,
        //         14,
        //         17
        //       )
        //     : null;
        //   height = 20;
        // } else if (
        //   this.filterDatas.supplierquery == "" ||
        //   this.filterDatas.supplierquery == null
        // ) {
        //   this.filterDatas.brandquery
        //     ? doc.text(`Brand    -    ${this.filterDatas.brandquery}`, 14, 12)
        //     : null;
        //   this.filterDatas.categoryquery
        //     ? doc.text(
        //         `Category       -    ${this.filterDatas.categoryquery}`,
        //         14,
        //         17
        //       )
        //     : null;
        //   height = 20;
        // } else {
        //   height = 25;
        //   this.filterDatas.supplierquery
        //     ? doc.text(
        //         `Supplier            -     ${this.filterDatas.supplierquery}`,
        //         15,
        //         12
        //       )
        //     : null;
        //   this.filterDatas.brandquery
        //     ? doc.text(
        //         `Brand      -     ${this.filterDatas.brandquery}`,
        //         15,
        //         17
        //       )
        //     : null;
        //     this.filterDatas.categoryquery
        //     ? doc.text(
        //         `Category      -     ${this.filterDatas.categoryquery}`,
        //         15,
        //         22
        //       )
        //     : null;

        // }

        const conditions = [
          { key: 'brandquery', label: 'Brand' },
          { key: 'categoryquery', label: 'Category' },
          { key: 'supplierquery', label: 'Supplier' },
        ];

        // Function to get text based on filter data
        const getText = (key, label, value) => {
          return value ? `${label} - ${value}` : '';
        };

        // Iterate over conditions and build the text
        let height = conditions.reduce((acc, condition) => {
          const value = this.filterDatas[condition.key];
          const text = getText(
            condition.key,
            condition.label,
            value,
            condition.offset,
          );

          if (text) {
            doc.text(text, 15, acc);
            return acc + 5;
          }

          return acc;
        }, 12); // Initial offset

        // Set a default height if no conditions matched
        height = height || 20;

        doc.autoTable(
          this.headers.map((h) => {
            return { title: h.text, dataKey: h.value };
          }),
          rows,
          {
            didParseCell: function (data) {
              if (data.column.dataKey === 'addsress') {
                data.cell.text = data.cell.raw.country;
              }
            },
            startY: height,
          },
        );
        const today = new DateTime();
        doc.save(`${moment(today).format('DD-MM-YYYY')}-Product.pdf`);
      };
      this.generateReport(printPdf);
    },
    //Product Details Export Excel
    exceldownload() {
      const printExcel = () => {
        var data = document.getElementById('indextable');
        const today = new DateTime();
        const headData = XLSX.utils.table_to_sheet(data);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          wb,
          headData,
          moment(today).format('DD-MM-YYYY'),
        );
        XLSX.writeFile(
          wb,
          `${moment(today).format('DD-MM-YYYY')}-Product.xlsx`,
        );
      };
      this.generateReport(printExcel);
    },
    goto(id) {
      var element = document.getElementById(id);
      element.scrollIntoView({ behavior: 'smooth' });
    },
  },
  computed: {
    ...mapState(['filterDatas']),
    headers: function () {
      return this.columns.filter((item) => item.show == true);
    },
  },
  created() {
    this.$store.commit('UPDATE_PDF_VISIBLE', false);
    this.$store.commit('UPDATE_PDFLOADNG_VISIBLE', false);
  },
  watch: {
    filter(value) {
      this.$store.commit('UPDATE_PDF_DATAS', null);
      this.$store.commit('UPDATE_PDF_VISIBLE', false);
    },
  },
};
</script>
<style>
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) {
  border-radius: 6px;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 31px;
}
</style>
